<template>
  <div class="table-responsive">
    <table class="table trips-table" :class="tableClass">
      <thead class="thead-light">
        <tr>
          <th v-for="n in columnCount" :key="n" scope="col">
            <div class="skeleton-box" style="height: 20px; width: 80%;"></div>
          </th>
          <th v-if="hasActions" scope="col">
            <div class="skeleton-box" style="height: 20px; width: 60px;"></div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rowCount" :key="row">
          <td v-for="col in columnCount" :key="col">
            <div class="skeleton-box" :style="`height: 18px; width: ${getRandomWidth()}%;`"></div>
          </td>
          <td v-if="hasActions">
            <div class="d-flex gap-2">
              <div class="skeleton-box" style="height: 30px; width: 30px; border-radius: 4px;"></div>
              <div class="skeleton-box" style="height: 30px; width: 30px; border-radius: 4px;"></div>
              <div class="skeleton-box" style="height: 30px; width: 30px; border-radius: 4px;"></div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "TableSkeleton",
  props: {
    columnCount: {
      type: Number,
      default: 3,
    },
    rowCount: {
      type: Number,
      default: 5,
    },
    hasActions: {
      type: Boolean,
      default: true,
    },
    tableClass: {
      type: [String, Array, Object],
      default: "",
    },
  },
  methods: {
    getRandomWidth() {
      // Returns a width between 50% and 95%
      return Math.floor(Math.random() * 45) + 50;
    },
  },
};
</script>

<style scoped>
.skeleton-box {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .skeleton-box {
    background: linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%);
    background-size: 200% 100%;
  }
}
</style>
